import { createFileRoute, redirect } from "@tanstack/react-router";

import Layout from "theme/ui/Layout";


export const Route = createFileRoute("/_public/auth")({
	component: () => <Layout.Auth />,
	beforeLoad: ({ context }) => {
		if (context.auth0?.isAuthenticated) throw redirect({ to: "/" });
	}
});